import './contentBox.scss';

import React from 'react';

import ContentSingle from './ContentSingle';

export default function ContentBox(props: { blocks: any[] }) {
    return (
        <div className='contentBlock'>
            <div className='container'>
                <div className='row'>
                    {props.blocks.map((block, index) => (
                        <ContentSingle block={block} key={index} />
                    ))}
                </div>
            </div>
        </div>
    );
}
